module.exports = __webpack_public_path__ + "media/images/bg/mosaic/camp-2-b7ea339063e2a26bc6c29a99fe18106a.jpg";